import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [

  { path: 'expired', loadChildren: () => import('./pages/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule) },

  {path: '', redirectTo: '/9e9d7cf4f2/service-info', pathMatch: 'full'},
  { path: ':token', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule) },

  { path: '**', loadChildren: () => import('./pages/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
